import { Location } from '@/models';
import { LocationDto } from '@/proxy';

export const toLocation = (data: LocationDto): Location => ({
  id: data.id,
  name: data.name,
  street: data.street,
  zip: data.zip,
  city: data.city,
  state: data.state,
  country: data.country,
  latitude: data.latitude,
  longitude: data.longitude,
  radius: data.radius,
  resourceCount: data.resourceCount,
});
